if (!customElements.get('mobile-sticky-bar')) {
  customElements.define(
    'mobile-sticky-bar',
    class MobileStickyBar extends HTMLElement {
      constructor() {
        super();

        this.classes = {
          enabled: 'mobile-sticky-bar-enabled',
          isShow: 'mobile-sticky-bar-up',
          isHide: 'mobile-sticky-bar-down',
        };

        this.compareToggleUnsubscriber = FoxTheme.pubsub.subscribe('compare:toggle', this.onCompareToggle.bind(this));
      }

      compareToggleUnsubscriber = undefined;

      connectedCallback() {
        document.body.classList.add(this.classes.enabled);
        if (this.isCompareBarShowing()) {
          this.hide();
        } else {
          this.show();
        }

        this.lastScrollTop = 0;
        this.scrollHandler = FoxTheme.utils.debounce(this.onScrollHandler.bind(this), 10);
        this.init();
        this.setupGorgiasChat();
        this.setupOffersLink();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.scrollHandler);

        if (this.compareToggleUnsubscriber) {
          this.compareToggleUnsubscriber();
        }
      }

      init() {
        this.calculateHeight();
        window.addEventListener('scroll', this.scrollHandler, false);
      }

      setupGorgiasChat() {
        const gorgiasButton = document.getElementById('GorgiasChatLink');
        if (gorgiasButton) {
          gorgiasButton.addEventListener('click', (e) => {
            e.preventDefault();
            if (window.GorgiasChat && typeof window.GorgiasChat.open === 'function') {
              window.GorgiasChat.open();
              this.renderCloseChatButton();
            }
          });
        }
      }

      renderCloseChatButton() {
        if (document.getElementById('close-gorgias-chat')) return;

        const closeButton = document.createElement('button');
        closeButton.id = 'close-gorgias-chat';
        closeButton.innerHTML = '&times;';
        closeButton.setAttribute('aria-label', 'Close chat');
        closeButton.style.cssText = `
            position: fixed;
            top: 15px !important;
            right: 15px !important;
            width: 44px;
            height: 44px;
            background: rgb(var(--color-button));
            color: rgb(255, 255, 255);
            font-weight: 400;
            border: none;
            font-size: 3rem;
            line-height: 1;
            cursor: pointer;
            z-index: 9999999991;
            display: flex;
            align-items: center;
            justify-content: center;
            box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 8px;
            padding: 0;
        `;

        closeButton.addEventListener('click', () => {
          if (window.GorgiasChat && typeof window.GorgiasChat.close === 'function') {
            window.GorgiasChat.close();
          }
          closeButton.remove();
        });

        closeButton.addEventListener('mouseenter', () => {
          closeButton.style.transform = 'scale(1.1)';
          closeButton.style.background = '#333';
        });

        closeButton.addEventListener('mouseleave', () => {
          closeButton.style.transform = 'scale(1)';
          closeButton.style.background = '#000';
        });

        document.body.appendChild(closeButton);
      }

      setupOffersLink() {
        const offersButton = document.getElementById('OffersLink');
        if (offersButton) {
          offersButton.addEventListener('click', (e) => {
            e.preventDefault();
            const spotlightToggle = document.querySelector('[data-toggle-spotlight]');
            if (spotlightToggle) {
              spotlightToggle.click();
            }
          });
        }
      }

      calculateHeight() {
        requestAnimationFrame(() => {
          document.documentElement.style.setProperty('--mobile-sticky-bar-height', `${this.offsetHeight}px`);
        });
      }

      isCompareBarShowing() {
        return document.body.classList.contains('is-product-comparing');
      }

      onCompareToggle(event) {
        if (event.isActive) {
          this.hide();
        } else {
          this.show();
        }
      }

      onScrollHandler() {
        if (this.isCompareBarShowing()) {
          this.hide();
          return;
        }

        const offsetTop = document.getElementById('mobileNavStatic').offsetTop;
        const scrollTop = window.scrollY;
        const pointTouch = offsetTop - scrollTop - window.innerHeight;

        requestAnimationFrame(() => {
          this.scrollDirection = scrollTop > this.lastScrollTop ? 'down' : 'up';
          this.lastScrollTop = scrollTop;

          if (this.scrollDirection == 'up' && pointTouch > 0) {
            this.show();
          } else {
            this.hide();
          }
        });
      }

      show() {
        document.body.classList.remove(this.classes.isHide);
        document.body.classList.add(this.classes.isShow);
      }

      hide() {
        document.body.classList.remove(this.classes.isShow);
        document.body.classList.add(this.classes.isHide);
      }
    }
  );
}
